/* eslint-disable camelcase */
import axios from 'axios'
import { instanceApi, instanceOEF, segundaVersaoOEF } from './api'
import { APIS } from '../config'


export const getEnderecoPorCEP = cep => {
  return axios.get( `${APIS.OEF_BASE_URL}/v2/endereco/consulta-cep/${cep}` ).then( response => response.data )
}

export const listaEnderecos = () => instanceApi.get( `v1/endereco` )

export const deletaEndereco = ( enderecoId, idAssinatura ) => instanceApi.delete( `/v1/endereco/${enderecoId}/${idAssinatura}` )

export const editaEndereco = endereco => instanceOEF.patch( `${segundaVersaoOEF}/endereco`, endereco )

export const cadastraEndereco = endereco => instanceOEF.post( `${segundaVersaoOEF}/endereco`, endereco )

export const cadastraEnderecoVigente = endereco => instanceOEF.patch( `${segundaVersaoOEF}/assinatura`, endereco )

export const envioUnicoRenovacao = ( associado_id, assinatura_id, cep, plano ) => instanceOEF.get( `${segundaVersaoOEF}/assinaturas/compensacao-envio-unico?&associado_id=${associado_id}&assinatura_id=${assinatura_id}&cep=${cep}&plano=${plano}` )

export const envioUnicoUpgrade = ( associado_id, cep, plano ) => instanceOEF.get( `${segundaVersaoOEF}/assinaturas/compensacao-envio-unico?&associado_id=${associado_id}&cep=${cep}&plano=${plano}` )
